export default {
      id: "i-tw-circle-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-tw-circle",
      toString: function () {
        return this.url;
      }
    }